import { render, staticRenderFns } from "./AbsencesEditorAdditionalInformation.vue?vue&type=template&id=7f462635&scoped=true&lang=pug&"
import script from "./AbsencesEditorAdditionalInformation.vue?vue&type=script&lang=ts&"
export * from "./AbsencesEditorAdditionalInformation.vue?vue&type=script&lang=ts&"
import style0 from "./AbsencesEditorAdditionalInformation.vue?vue&type=style&index=0&id=7f462635&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f462635",
  null
  
)

export default component.exports